import { User, UserPlus, UserCheck, LogOut, Shield } from 'lucide-react';
import { WrenchIcon } from '../components/ui/icons/WrenchIcon';

export function getAccountDropdownItems(t: any, navigate: any, isAdmin: boolean = false) {
  const user = localStorage.getItem('user');
  if (user) {
    const items = [
      {
        id: 'to-account',
        label: t('go_to_account'),
        icon: User,
        onClick: () => navigate('/user')
      },
      {
        id: 'manage-account',
        label: t('manage_account'),
        icon: WrenchIcon,
        onClick: () => navigate('/user/settings')
      }
    ];
    
    // Добавляем кнопку админ панели только для админов
    if (isAdmin) {
      items.push({
        id: 'admin',
        label: t('admin_panel'),
        icon: Shield,
        onClick: () => navigate('/admin')
      });
    }
    
    items.push({
        id: 'logout',
        label: t('logout'),
        icon: LogOut,
        onClick: () => {
          localStorage.removeItem('user');
          sessionStorage.clear();
          navigate('/');
        }
    });
    
    return items;
  }
  return [
    {
      id: 'create',
      label: t('create_account'),
      icon: UserPlus,
      onClick: () => navigate('/register')
    },
    {
      id: 'login',
      label: t('login'),
      icon: UserCheck,
      onClick: () => navigate('/login')
    }
  ];
} 